import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=3190c01c&scoped=true"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
import style0 from "./accounts.vue?vue&type=style&index=0&id=3190c01c&prod&lang=less&scoped=true"
import style1 from "./accounts.vue?vue&type=style&index=1&id=3190c01c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190c01c",
  null
  
)

export default component.exports